module.exports = __webpack_public_path__ + "static/media/sGrSettings.1cba2293.png";